module.exports = __webpack_public_path__ + "img/lightning.8015c6ac.svg";